import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CalificacionDocumento } from '../../types/CalificacionDocumento';
import { DocumentoHabilitacion } from '../../types/DocumentoHabilitacion';
import { DocumentoPersonalHabilitacion } from '../../types/DocumentoPersonalHabilitacion';

interface CalificacionHabilitacionState {
    documentosParaCalificar: DocumentoHabilitacion[];
    documentosPersonalParaCalificar: DocumentoPersonalHabilitacion[];
    calificacionSelected: CalificacionDocumento;
    loading: boolean;
}

export const calificacionInitial: CalificacionDocumento = {
    status: '',
    observacion: '',
};

const initialState: CalificacionHabilitacionState = {
    documentosParaCalificar: [],
    documentosPersonalParaCalificar: [],
    calificacionSelected: calificacionInitial,
    loading: false,
};

export const calificacionHabilitacionSlice = createSlice({
    name: 'calificacionHabilitacion',
    initialState,
    reducers: {
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadDocumentosParaCalificar: (state, data: PayloadAction<DocumentoHabilitacion[]>): void => {
            state.documentosParaCalificar = data.payload;
            state.loading = false;
        },
        loadDocumentosPersonalParaCalificar: (state, data: PayloadAction<DocumentoPersonalHabilitacion[]>): void => {
            state.documentosPersonalParaCalificar = data.payload;
            state.loading = false;
        },
        setCalificacionSelected: (state, data: PayloadAction<CalificacionDocumento>): void => {
            state.calificacionSelected = data.payload;
        },
        resetCalificacion: (state): void => {
            state.documentosParaCalificar = [];
            state.documentosPersonalParaCalificar = [];
            state.calificacionSelected = calificacionInitial;
            state.loading = false;
        },
    },
});

export const {
    isLoading,
    loadDocumentosParaCalificar,
    loadDocumentosPersonalParaCalificar,
    setCalificacionSelected,
    resetCalificacion,
} = calificacionHabilitacionSlice.actions;
export default calificacionHabilitacionSlice.reducer;
